import ViewResolver from '@Components/ViewResolver/ViewResolver';
import { User, UserReplacement } from '@Types/index';

import { EmployeeSelectDesktop } from './desktop';
import { EmployeeSelectMobile } from './mobile';

interface EmployeeSelectProps {
  isOpen: boolean;
  users: UserReplacement[] | User[];
  title: string;
  onSearchChange: React.ChangeEventHandler<HTMLInputElement>;
  onClose: () => void;
  onUserSelect: (user: UserReplacement | User | null) => void;
  onLoadMore?: () => void;
}

const EmployeeSelect: React.FC<EmployeeSelectProps> = (props) => {
  const {
    isOpen,
    users,
    onSearchChange,
    onClose,
    onUserSelect,
    title,
    onLoadMore,
  } = props;

  return (
    <ViewResolver
      desktop={
        <EmployeeSelectDesktop
          isOpen={isOpen}
          users={users}
          onSearchChange={onSearchChange}
          onClose={onClose}
          onUserSelect={onUserSelect}
          onLoadMore={onLoadMore}
          title={title}
        />
      }
      mobile={
        <EmployeeSelectMobile
          isOpen={isOpen}
          users={users}
          onSearchChange={onSearchChange}
          onClose={onClose}
          onUserSelect={onUserSelect}
          onLoadMore={onLoadMore}
        />
      }
    />
  );
};

export default EmployeeSelect;
